import { serializable, deserialize } from 'serializr';

export class FeedbackModel {
  @serializable
  public description: string;

  @serializable
  public pageUrl: string;

  @serializable
  public rating: number;

  @serializable
  public userId: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(FeedbackModel, input));
  }
}
